<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs" />
<div class="border-b border-solid border-slate-300"></div>

<div class="layout-padding mx-auto max-w-screen-2xl">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    @for (link of navLinks; track $index) {
      <a
        #rla="routerLinkActive"
        mat-tab-link
        routerLinkActive
        [routerLink]="link.path"
        [active]="rla.isActive"
      >
        {{ link.label }}
      </a>
    }
  </nav>

  <mat-tab-nav-panel #tabPanel>
    <div class="layout-margin">
      <pr-sterilisation-table-filters [practice]="practice$ | async">
        <pt-buttons-container>
          <span
            *ngrxLet="store.canAddSteriCycle$ as canAddSteriCycle"
            matTooltip="No machines configured"
            [matTooltipDisabled]="canAddSteriCycle"
          >
            <button
              mat-flat-button
              color="primary"
              [disabled]="!canAddSteriCycle"
              (click)="addSteriCycle()"
            >
              Add Cycle
            </button>
          </span>

          <button mat-flat-button color="primary" (click)="addSteriRecord()">
            Add Record
          </button>

          <button mat-flat-button color="primary" (click)="printBarcodes()">
            Print Barcodes
          </button>
        </pt-buttons-container>
      </pr-sterilisation-table-filters>
    </div>

    <router-outlet />
  </mat-tab-nav-panel>
</div>
